/* tslint:disable */
/* eslint-disable */
/**
 * CalculadoraEcharger-api
 * Api CalculadoraEcharger
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import type {ExtendedAxiosRequestConfig} from './common';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, setBearerAuthToFormData } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export const defaultExtendedAxiosRequestConfig : ExtendedAxiosRequestConfig = {extensions: {}}

/**
 * 
 * @export
 * @interface CargadorAgrupadoRm
 */
export interface CargadorAgrupadoRm {
    /**
     * 
     * @type {number}
     * @memberof CargadorAgrupadoRm
     */
    'Id': number;
    /**
     * 
     * @type {number}
     * @memberof CargadorAgrupadoRm
     */
    'Latitud': number;
    /**
     * 
     * @type {number}
     * @memberof CargadorAgrupadoRm
     */
    'Longitud': number;
    /**
     * 
     * @type {string}
     * @memberof CargadorAgrupadoRm
     */
    'Direccion': string;
    /**
     * 
     * @type {number}
     * @memberof CargadorAgrupadoRm
     */
    'Potencia': number;
    /**
     * 
     * @type {number}
     * @memberof CargadorAgrupadoRm
     */
    'Libre': number;
    /**
     * 
     * @type {number}
     * @memberof CargadorAgrupadoRm
     */
    'Total': number;
    /**
     * 
     * @type {number}
     * @memberof CargadorAgrupadoRm
     */
    'DistanciaM': number;
    /**
     * 
     * @type {number}
     * @memberof CargadorAgrupadoRm
     */
    'PotenciaEfectivaKw': number;
    /**
     * 
     * @type {number}
     * @memberof CargadorAgrupadoRm
     */
    'PrecioKwh': number;
    /**
     * 
     * @type {number}
     * @memberof CargadorAgrupadoRm
     */
    'TiempoCarga': number;
    /**
     * 
     * @type {number}
     * @memberof CargadorAgrupadoRm
     */
    'CosteTotal': number;
    /**
     * 
     * @type {number}
     * @memberof CargadorAgrupadoRm
     */
    'IdTarifa': number;
}
/**
 * 
 * @export
 * @interface CargadorAgrupadoRmListResponseDTO
 */
export interface CargadorAgrupadoRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof CargadorAgrupadoRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof CargadorAgrupadoRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof CargadorAgrupadoRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CargadorAgrupadoRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof CargadorAgrupadoRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CargadorAgrupadoRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<CargadorAgrupadoRm>}
     * @memberof CargadorAgrupadoRmListResponseDTO
     */
    'Data'?: Array<CargadorAgrupadoRm>;
    /**
     * 
     * @type {any}
     * @memberof CargadorAgrupadoRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CargadorOrderByEnum = {
    Id: 'Id',
    Distancia: 'Distancia',
    Precio: 'Precio',
    Tiempo: 'Tiempo',
    Potencia: 'Potencia'
} as const;

export type CargadorOrderByEnum = typeof CargadorOrderByEnum[keyof typeof CargadorOrderByEnum];


/**
 * 
 * @export
 * @interface CocheElectricoMarcaRm
 */
export interface CocheElectricoMarcaRm {
    /**
     * 
     * @type {number}
     * @memberof CocheElectricoMarcaRm
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof CocheElectricoMarcaRm
     */
    'Nombre': string;
}
/**
 * 
 * @export
 * @interface CocheElectricoMarcaRmListResponseDTO
 */
export interface CocheElectricoMarcaRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof CocheElectricoMarcaRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof CocheElectricoMarcaRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof CocheElectricoMarcaRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CocheElectricoMarcaRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof CocheElectricoMarcaRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CocheElectricoMarcaRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<CocheElectricoMarcaRm>}
     * @memberof CocheElectricoMarcaRmListResponseDTO
     */
    'Data'?: Array<CocheElectricoMarcaRm>;
    /**
     * 
     * @type {any}
     * @memberof CocheElectricoMarcaRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface CocheElectricoRm
 */
export interface CocheElectricoRm {
    /**
     * 
     * @type {string}
     * @memberof CocheElectricoRm
     */
    'Id': string;
    /**
     * 
     * @type {number}
     * @memberof CocheElectricoRm
     */
    'IdCocheElectricoMarca': number;
    /**
     * 
     * @type {string}
     * @memberof CocheElectricoRm
     */
    'CocheElectricoMarca': string;
    /**
     * 
     * @type {string}
     * @memberof CocheElectricoRm
     */
    'Modelo': string;
    /**
     * 
     * @type {string}
     * @memberof CocheElectricoRm
     */
    'Version': string;
    /**
     * 
     * @type {number}
     * @memberof CocheElectricoRm
     */
    'CapacidadKwh': number;
    /**
     * 
     * @type {number}
     * @memberof CocheElectricoRm
     */
    'PotenciaAcKw': number;
    /**
     * 
     * @type {number}
     * @memberof CocheElectricoRm
     */
    'PotenciaCargaDcKw': number;
    /**
     * 
     * @type {Date}
     * @memberof CocheElectricoRm
     */
    'FechaBaja': Date | null;
}
/**
 * 
 * @export
 * @interface CocheElectricoRmListResponseDTO
 */
export interface CocheElectricoRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof CocheElectricoRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof CocheElectricoRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof CocheElectricoRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CocheElectricoRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof CocheElectricoRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CocheElectricoRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<CocheElectricoRm>}
     * @memberof CocheElectricoRmListResponseDTO
     */
    'Data'?: Array<CocheElectricoRm>;
    /**
     * 
     * @type {any}
     * @memberof CocheElectricoRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface DXLoadOptions
 */
export interface DXLoadOptions {
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'requireTotalCount'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'requireGroupCount'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'isCountQuery'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'isSummaryQuery'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DXLoadOptions
     */
    'skip'?: number;
    /**
     * 
     * @type {number}
     * @memberof DXLoadOptions
     */
    'take'?: number;
    /**
     * 
     * @type {Array<SortingInfo>}
     * @memberof DXLoadOptions
     */
    'sort'?: Array<SortingInfo> | null;
    /**
     * 
     * @type {Array<GroupingInfo>}
     * @memberof DXLoadOptions
     */
    'group'?: Array<GroupingInfo> | null;
    /**
     * 
     * @type {Array<SummaryInfo>}
     * @memberof DXLoadOptions
     */
    'totalSummary'?: Array<SummaryInfo> | null;
    /**
     * 
     * @type {Array<SummaryInfo>}
     * @memberof DXLoadOptions
     */
    'groupSummary'?: Array<SummaryInfo> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DXLoadOptions
     */
    'select'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DXLoadOptions
     */
    'preSelect'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'remoteSelect'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'remoteGrouping'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'expandLinqSumType'?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DXLoadOptions
     */
    'primaryKey'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DXLoadOptions
     */
    'defaultSort'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'stringToLower'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'paginateViaPrimaryKey'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'sortByPrimaryKey'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'allowAsyncOverSync'?: boolean;
    /**
     * 
     * @type {Array<any>}
     * @memberof DXLoadOptions
     */
    'filter': Array<any> | null;
}
/**
 * 
 * @export
 * @interface DefaultResponseDTO
 */
export interface DefaultResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DefaultResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DefaultResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof DefaultResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DefaultResponseDTO
     */
    'CorrelationId'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DefaultResponseStatus = {
    NotSet: 'NotSet',
    Ok: 'Ok',
    UnhandledException: 'UnhandledException',
    InvalidArguments: 'InvalidArguments',
    ConcurrencyError: 'ConcurrencyError',
    OutOfService: 'OutOfService',
    Unauthorized: 'Unauthorized'
} as const;

export type DefaultResponseStatus = typeof DefaultResponseStatus[keyof typeof DefaultResponseStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const DefaultResponseStatusCategory = {
    NotSet: 'NotSet',
    Ok: 'Ok',
    TransientError: 'TransientError',
    PermanentError: 'PermanentError'
} as const;

export type DefaultResponseStatusCategory = typeof DefaultResponseStatusCategory[keyof typeof DefaultResponseStatusCategory];


/**
 * 
 * @export
 * @interface GroupingInfo
 */
export interface GroupingInfo {
    /**
     * 
     * @type {string}
     * @memberof GroupingInfo
     */
    'selector'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupingInfo
     */
    'desc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupingInfo
     */
    'groupInterval'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupingInfo
     */
    'isExpanded'?: boolean | null;
}
/**
 * 
 * @export
 * @interface LoadResult
 */
export interface LoadResult {
    /**
     * 
     * @type {Array<any>}
     * @memberof LoadResult
     */
    'data'?: Array<any> | null;
    /**
     * 
     * @type {number}
     * @memberof LoadResult
     */
    'totalCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof LoadResult
     */
    'groupCount'?: number;
    /**
     * 
     * @type {Array<any>}
     * @memberof LoadResult
     */
    'summary'?: Array<any> | null;
}
/**
 * 
 * @export
 * @interface SortingInfo
 */
export interface SortingInfo {
    /**
     * 
     * @type {string}
     * @memberof SortingInfo
     */
    'selector'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SortingInfo
     */
    'desc'?: boolean;
}
/**
 * 
 * @export
 * @interface SummaryInfo
 */
export interface SummaryInfo {
    /**
     * 
     * @type {string}
     * @memberof SummaryInfo
     */
    'selector'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryInfo
     */
    'summaryType'?: string | null;
}
/**
 * 
 * @export
 * @interface TarifaNombreRm
 */
export interface TarifaNombreRm {
    /**
     * 
     * @type {number}
     * @memberof TarifaNombreRm
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof TarifaNombreRm
     */
    'CodigoTarifa': string;
    /**
     * 
     * @type {string}
     * @memberof TarifaNombreRm
     */
    'NombreTarifa': string;
}
/**
 * 
 * @export
 * @interface TarifaNombreRmListResponseDTO
 */
export interface TarifaNombreRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof TarifaNombreRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof TarifaNombreRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof TarifaNombreRmListResponseDTO
     */
    'Ok': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TarifaNombreRmListResponseDTO
     */
    'IsTransient': boolean;
    /**
     * 
     * @type {string}
     * @memberof TarifaNombreRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof TarifaNombreRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<TarifaNombreRm>}
     * @memberof TarifaNombreRmListResponseDTO
     */
    'Data'?: Array<TarifaNombreRm>;
    /**
     * 
     * @type {any}
     * @memberof TarifaNombreRmListResponseDTO
     */
    'Extra'?: any;
}



  
export const CalculadoraEchargerApiApiRoutes = {
    featuresGet: "/features/{featureName}",
    featuresList: "/features",
    getCargadorAll: "/api/v1.0/Commons/Cargador/GetCargadorAll",
    getCocheElectricoByIdMarca: "/api/v1.0/Commons/CocheElectrico/GetCocheElectricoByIdMarca",
    getCocheElectricoMarca: "/api/v1.0/Commons/CocheElectrico/GetCocheElectricoMarca",
    tarifaGetNombreAll: "/api/v1.0/Commons/Tarifa/GetTarifaNombreAll",
}
  
/**
 * CalculadoraEchargerApiApi - axios parameter creator
 * @export
 */
export const CalculadoraEchargerApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
  

         
      
      
        /**
         * 
         * @summary Obtiene valor de activación de una feature
         * @param {string} FeatureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresGet: async (FeatureName: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'FeatureName' is set
            assertParamExists('featuresGet', 'FeatureName',false,false, FeatureName)
    
            const localVarPath = `/features/{featureName}`
                .replace(`{${"featureName"}}`, encodeURIComponent(String(FeatureName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        

    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la lista de feature flags y valor de activación
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresList: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        

    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene todos los cargadores eléctricos desde la vista v_cargador_agrupado
         * @param {number} Take 
         * @param {number} Skip 
         * @param {number} BateriaInicial 
         * @param {number} BateriaFinal 
         * @param {string} IdCocheElectrico 
         * @param {number} IdTarifaNombre 
         * @param {number} Latitud 
         * @param {number} Longitud 
         * @param {CargadorOrderByEnum} OrderBy 
         * @param {boolean | null} [SoloLibres] 
         * @param {string} [HoraCliente] 
         * @param {number | null} [PrecioHasta] 
         * @param {number | null} [RadioMetros] 
         * @param {number | null} [TiempoMaximo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadorAll: async (Take: number, Skip: number, BateriaInicial: number, BateriaFinal: number, IdCocheElectrico: string, IdTarifaNombre: number, Latitud: number, Longitud: number, OrderBy: CargadorOrderByEnum, SoloLibres?: boolean | null, HoraCliente?: string, PrecioHasta?: number | null, RadioMetros?: number | null, TiempoMaximo?: number | null, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Take' is set
            assertParamExists('getCargadorAll', 'Take',false,false, Take)
    
            // verify required parameter 'Skip' is set
            assertParamExists('getCargadorAll', 'Skip',false,false, Skip)
    
            // verify required parameter 'BateriaInicial' is set
            assertParamExists('getCargadorAll', 'BateriaInicial',false,false, BateriaInicial)
    
            // verify required parameter 'BateriaFinal' is set
            assertParamExists('getCargadorAll', 'BateriaFinal',false,false, BateriaFinal)
    
            // verify required parameter 'IdCocheElectrico' is set
            assertParamExists('getCargadorAll', 'IdCocheElectrico',false,false, IdCocheElectrico)
    
            // verify required parameter 'IdTarifaNombre' is set
            assertParamExists('getCargadorAll', 'IdTarifaNombre',false,false, IdTarifaNombre)
    
            // verify required parameter 'Latitud' is set
            assertParamExists('getCargadorAll', 'Latitud',false,false, Latitud)
    
            // verify required parameter 'Longitud' is set
            assertParamExists('getCargadorAll', 'Longitud',false,false, Longitud)
    
            // verify required parameter 'OrderBy' is set
            assertParamExists('getCargadorAll', 'OrderBy',false,false, OrderBy)
    
    
    
    // verify required parameter 'HoraCliente' is set
            assertParamExists('getCargadorAll', 'HoraCliente',true,false, HoraCliente)
    
    
    
    
            const localVarPath = `/api/v1.0/Commons/Cargador/GetCargadorAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            if (Take !== undefined) {
                localVarQueryParameter['Take'] = Take;
            }

            if (Skip !== undefined) {
                localVarQueryParameter['Skip'] = Skip;
            }

            if (BateriaInicial !== undefined) {
                localVarQueryParameter['BateriaInicial'] = BateriaInicial;
            }

            if (BateriaFinal !== undefined) {
                localVarQueryParameter['BateriaFinal'] = BateriaFinal;
            }

            if (IdCocheElectrico !== undefined) {
                localVarQueryParameter['IdCocheElectrico'] = IdCocheElectrico;
            }

            if (IdTarifaNombre !== undefined) {
                localVarQueryParameter['IdTarifaNombre'] = IdTarifaNombre;
            }

            if (Latitud !== undefined) {
                localVarQueryParameter['Latitud'] = Latitud;
            }

            if (Longitud !== undefined) {
                localVarQueryParameter['Longitud'] = Longitud;
            }

            if (OrderBy !== undefined) {
                localVarQueryParameter['OrderBy'] = OrderBy;
            }

            if (SoloLibres !== undefined) {
                localVarQueryParameter['SoloLibres'] = SoloLibres;
            }

            if (HoraCliente !== undefined) {
                localVarQueryParameter['HoraCliente'] = HoraCliente;
            }

            if (PrecioHasta !== undefined) {
                localVarQueryParameter['PrecioHasta'] = PrecioHasta;
            }

            if (RadioMetros !== undefined) {
                localVarQueryParameter['RadioMetros'] = RadioMetros;
            }

            if (TiempoMaximo !== undefined) {
                localVarQueryParameter['TiempoMaximo'] = TiempoMaximo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene los coches electricos por marca
         * @param {number} IdCocheElectricoMarca 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCocheElectricoByIdMarca: async (IdCocheElectricoMarca: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdCocheElectricoMarca' is set
            assertParamExists('getCocheElectricoByIdMarca', 'IdCocheElectricoMarca',false,false, IdCocheElectricoMarca)
    
            const localVarPath = `/api/v1.0/Commons/CocheElectrico/GetCocheElectricoByIdMarca`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            if (IdCocheElectricoMarca !== undefined) {
                localVarQueryParameter['IdCocheElectricoMarca'] = IdCocheElectricoMarca;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene todas las marcas de coches eléctricos desde la vista v_coche_electrico_marca
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCocheElectricoMarca: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/v1.0/Commons/CocheElectrico/GetCocheElectricoMarca`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        

    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene todas las tarifas disponibles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tarifaGetNombreAll: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/v1.0/Commons/Tarifa/GetTarifaNombreAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        

    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculadoraEchargerApiApi - functional programming interface
 * @export
 */
export const CalculadoraEchargerApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalculadoraEchargerApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Obtiene valor de activación de una feature
         * @param {string} FeatureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresGet(FeatureName: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresGet(FeatureName, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CalculadoraEchargerApiApi.featuresGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la lista de feature flags y valor de activación
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresList(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresList(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CalculadoraEchargerApiApi.featuresList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene todos los cargadores eléctricos desde la vista v_cargador_agrupado
         * @param {number} Take 
         * @param {number} Skip 
         * @param {number} BateriaInicial 
         * @param {number} BateriaFinal 
         * @param {string} IdCocheElectrico 
         * @param {number} IdTarifaNombre 
         * @param {number} Latitud 
         * @param {number} Longitud 
         * @param {CargadorOrderByEnum} OrderBy 
         * @param {boolean | null} [SoloLibres] 
         * @param {string} [HoraCliente] 
         * @param {number | null} [PrecioHasta] 
         * @param {number | null} [RadioMetros] 
         * @param {number | null} [TiempoMaximo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCargadorAll(Take: number, Skip: number, BateriaInicial: number, BateriaFinal: number, IdCocheElectrico: string, IdTarifaNombre: number, Latitud: number, Longitud: number, OrderBy: CargadorOrderByEnum, SoloLibres?: boolean | null, HoraCliente?: string, PrecioHasta?: number | null, RadioMetros?: number | null, TiempoMaximo?: number | null, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CargadorAgrupadoRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCargadorAll(Take, Skip, BateriaInicial, BateriaFinal, IdCocheElectrico, IdTarifaNombre, Latitud, Longitud, OrderBy, SoloLibres, HoraCliente, PrecioHasta, RadioMetros, TiempoMaximo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CalculadoraEchargerApiApi.getCargadorAll']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene los coches electricos por marca
         * @param {number} IdCocheElectricoMarca 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCocheElectricoByIdMarca(IdCocheElectricoMarca: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CocheElectricoRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCocheElectricoByIdMarca(IdCocheElectricoMarca, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CalculadoraEchargerApiApi.getCocheElectricoByIdMarca']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene todas las marcas de coches eléctricos desde la vista v_coche_electrico_marca
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCocheElectricoMarca(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CocheElectricoMarcaRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCocheElectricoMarca(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CalculadoraEchargerApiApi.getCocheElectricoMarca']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene todas las tarifas disponibles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tarifaGetNombreAll(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TarifaNombreRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tarifaGetNombreAll(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CalculadoraEchargerApiApi.tarifaGetNombreAll']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * CalculadoraEchargerApiApi - factory interface
 * @export
 */
export const CalculadoraEchargerApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalculadoraEchargerApiApiFp(configuration)
    return {
        /**
         * 
         * @summary Obtiene valor de activación de una feature
         * @param {string} FeatureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresGet(FeatureName: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.featuresGet(FeatureName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la lista de feature flags y valor de activación
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresList(options?: any): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.featuresList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene todos los cargadores eléctricos desde la vista v_cargador_agrupado
         * @param {number} Take 
         * @param {number} Skip 
         * @param {number} BateriaInicial 
         * @param {number} BateriaFinal 
         * @param {string} IdCocheElectrico 
         * @param {number} IdTarifaNombre 
         * @param {number} Latitud 
         * @param {number} Longitud 
         * @param {CargadorOrderByEnum} OrderBy 
         * @param {boolean | null} [SoloLibres] 
         * @param {string} [HoraCliente] 
         * @param {number | null} [PrecioHasta] 
         * @param {number | null} [RadioMetros] 
         * @param {number | null} [TiempoMaximo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCargadorAll(Take: number, Skip: number, BateriaInicial: number, BateriaFinal: number, IdCocheElectrico: string, IdTarifaNombre: number, Latitud: number, Longitud: number, OrderBy: CargadorOrderByEnum, SoloLibres?: boolean | null, HoraCliente?: string, PrecioHasta?: number | null, RadioMetros?: number | null, TiempoMaximo?: number | null, options?: any): AxiosPromise<CargadorAgrupadoRmListResponseDTO> {
            return localVarFp.getCargadorAll(Take, Skip, BateriaInicial, BateriaFinal, IdCocheElectrico, IdTarifaNombre, Latitud, Longitud, OrderBy, SoloLibres, HoraCliente, PrecioHasta, RadioMetros, TiempoMaximo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene los coches electricos por marca
         * @param {number} IdCocheElectricoMarca 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCocheElectricoByIdMarca(IdCocheElectricoMarca: number, options?: any): AxiosPromise<CocheElectricoRmListResponseDTO> {
            return localVarFp.getCocheElectricoByIdMarca(IdCocheElectricoMarca, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene todas las marcas de coches eléctricos desde la vista v_coche_electrico_marca
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCocheElectricoMarca(options?: any): AxiosPromise<CocheElectricoMarcaRmListResponseDTO> {
            return localVarFp.getCocheElectricoMarca(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene todas las tarifas disponibles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tarifaGetNombreAll(options?: any): AxiosPromise<TarifaNombreRmListResponseDTO> {
            return localVarFp.tarifaGetNombreAll(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalculadoraEchargerApiApi - object-oriented interface
 * @export
 * @class CalculadoraEchargerApiApi
 * @extends {BaseAPI}
 */
export class CalculadoraEchargerApiApi extends BaseAPI {
    /**
     * 
     * @summary Obtiene valor de activación de una feature
     * @param {string} FeatureName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculadoraEchargerApiApi
     */
    public featuresGet(FeatureName: string, options?: ExtendedAxiosRequestConfig) {
        return CalculadoraEchargerApiApiFp(this.configuration).featuresGet(FeatureName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la lista de feature flags y valor de activación
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculadoraEchargerApiApi
     */
    public featuresList(options?: ExtendedAxiosRequestConfig) {
        return CalculadoraEchargerApiApiFp(this.configuration).featuresList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene todos los cargadores eléctricos desde la vista v_cargador_agrupado
     * @param {number} Take 
     * @param {number} Skip 
     * @param {number} BateriaInicial 
     * @param {number} BateriaFinal 
     * @param {string} IdCocheElectrico 
     * @param {number} IdTarifaNombre 
     * @param {number} Latitud 
     * @param {number} Longitud 
     * @param {CargadorOrderByEnum} OrderBy 
     * @param {boolean | null} [SoloLibres] 
     * @param {string} [HoraCliente] 
     * @param {number | null} [PrecioHasta] 
     * @param {number | null} [RadioMetros] 
     * @param {number | null} [TiempoMaximo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculadoraEchargerApiApi
     */
    public getCargadorAll(Take: number, Skip: number, BateriaInicial: number, BateriaFinal: number, IdCocheElectrico: string, IdTarifaNombre: number, Latitud: number, Longitud: number, OrderBy: CargadorOrderByEnum, SoloLibres?: boolean | null, HoraCliente?: string, PrecioHasta?: number | null, RadioMetros?: number | null, TiempoMaximo?: number | null, options?: ExtendedAxiosRequestConfig) {
        return CalculadoraEchargerApiApiFp(this.configuration).getCargadorAll(Take, Skip, BateriaInicial, BateriaFinal, IdCocheElectrico, IdTarifaNombre, Latitud, Longitud, OrderBy, SoloLibres, HoraCliente, PrecioHasta, RadioMetros, TiempoMaximo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene los coches electricos por marca
     * @param {number} IdCocheElectricoMarca 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculadoraEchargerApiApi
     */
    public getCocheElectricoByIdMarca(IdCocheElectricoMarca: number, options?: ExtendedAxiosRequestConfig) {
        return CalculadoraEchargerApiApiFp(this.configuration).getCocheElectricoByIdMarca(IdCocheElectricoMarca, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene todas las marcas de coches eléctricos desde la vista v_coche_electrico_marca
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculadoraEchargerApiApi
     */
    public getCocheElectricoMarca(options?: ExtendedAxiosRequestConfig) {
        return CalculadoraEchargerApiApiFp(this.configuration).getCocheElectricoMarca(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene todas las tarifas disponibles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculadoraEchargerApiApi
     */
    public tarifaGetNombreAll(options?: ExtendedAxiosRequestConfig) {
        return CalculadoraEchargerApiApiFp(this.configuration).tarifaGetNombreAll(options).then((request) => request(this.axios, this.basePath));
    }
}



